<template>
  <v-expansion-panels focusable>
    <!-- Panels -->
    <v-expansion-panel class="mb-2">
      <v-expansion-panel-header
        >{{ $t('question_1'), }}</v-expansion-panel-header
      >
      <v-expansion-panel-content>
        <img
          src="@/assets/images/white_right_arrow.png"
          alt="White right arrow"
          class="mr-4"
        />
        <span v-html="$t('answer_1')"></span>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel class="mb-2">
      <v-expansion-panel-header
        >{{ $t('question_2'), }}</v-expansion-panel-header
      >
      <v-expansion-panel-content>
        <img
          src="@/assets/images/white_right_arrow.png"
          alt="White right arrow"
          class="mr-4"
        />
        <span v-html="$t('answer_2')"></span>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel class="mb-2">
      <v-expansion-panel-header
        >{{ $t('question_3'), }}</v-expansion-panel-header
      >
      <v-expansion-panel-content>
        <img
          src="@/assets/images/white_right_arrow.png"
          alt="White right arrow"
          class="mr-4"
        />
        <span v-html="$t('answer_3')"></span>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel class="mb-2">
      <v-expansion-panel-header
        >{{ $t('question_4'), }}</v-expansion-panel-header
      >
      <v-expansion-panel-content>
        <img
          src="@/assets/images/white_right_arrow.png"
          alt="White right arrow"
          class="mr-4"
        />
        <span v-html="$t('answer_4')"></span>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel class="mb-2">
      <v-expansion-panel-header
        >{{ $t('question_5'), }}</v-expansion-panel-header
      >
      <v-expansion-panel-content>
        <img
          src="@/assets/images/white_right_arrow.png"
          alt="White right arrow"
          class="mr-4"
        />
        <span v-html="$t('answer_5')"></span>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel class="mb-2">
      <v-expansion-panel-header
        >{{ $t('question_6'), }}</v-expansion-panel-header
      >
      <v-expansion-panel-content>
        <img
          src="@/assets/images/white_right_arrow.png"
          alt="White right arrow"
          class="mr-4"
        />
        <div class="faq-table-wrapper">
          <answer-table />
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel class="mb-2">
      <v-expansion-panel-header
        >{{ $t('question_7'), }}</v-expansion-panel-header
      >
      <v-expansion-panel-content>
        <img
          src="@/assets/images/white_right_arrow.png"
          alt="White right arrow"
          class="mr-4"
        />
        <span v-html="$t('answer_7')"></span>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel class="mb-2">
      <v-expansion-panel-header
        >{{ $t('question_8'), }}</v-expansion-panel-header
      >
      <v-expansion-panel-content>
        <img
          src="@/assets/images/white_right_arrow.png"
          alt="White right arrow"
          class="mr-4"
        />
        <span v-html="$t('answer_8')"></span>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel class="mb-2">
      <v-expansion-panel-header
        >{{ $t('question_9'), }}</v-expansion-panel-header
      >
      <v-expansion-panel-content>
        <img
          src="@/assets/images/white_right_arrow.png"
          alt="White right arrow"
          class="mr-4"
        />
        <span v-html="$t('answer_9')"></span>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel class="mb-2">
      <v-expansion-panel-header
        >{{ $t('question_10'), }}</v-expansion-panel-header
      >
      <v-expansion-panel-content>
        <img
          src="@/assets/images/white_right_arrow.png"
          alt="White right arrow"
          class="mr-4"
        />
        <span v-html="$t('answer_10')"></span>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel class="mb-2">
      <v-expansion-panel-header
        >{{ $t('question_11'), }}</v-expansion-panel-header
      >
      <v-expansion-panel-content>
        <img
          src="@/assets/images/white_right_arrow.png"
          alt="White right arrow"
          class="mr-4"
        />
        <span v-html="$t('answer_11')"></span>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel class="mb-2">
      <v-expansion-panel-header
        >{{ $t('question_12'), }}</v-expansion-panel-header
      >
      <v-expansion-panel-content>
        <img
          src="@/assets/images/white_right_arrow.png"
          alt="White right arrow"
          class="mr-4"
        />
        <span v-html="$t('answer_12')"></span>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel class="mb-2">
      <v-expansion-panel-header
        >{{ $t('question_13'), }}</v-expansion-panel-header
      >
      <v-expansion-panel-content>
        <img
          src="@/assets/images/white_right_arrow.png"
          alt="White right arrow"
          class="mr-4"
        />
        <span v-html="$t('answer_13')"></span>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel class="mb-2">
      <v-expansion-panel-header
        >{{ $t('question_14'), }}</v-expansion-panel-header
      >
      <v-expansion-panel-content>
        <img
          src="@/assets/images/white_right_arrow.png"
          alt="White right arrow"
          class="mr-4"
        />
        <span v-html="$t('answer_14')"></span>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel class="mb-2">
      <v-expansion-panel-header
        >{{ $t('question_15'), }}</v-expansion-panel-header
      >
      <v-expansion-panel-content>
        <img
          src="@/assets/images/white_right_arrow.png"
          alt="White right arrow"
          class="mr-4"
        />
        <span v-html="$t('answer_15')"></span>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import answerTable from "../answerTable.vue";

export default {
  data() {
    return {
      htmlContent: "",
    };
  },
  components: { answerTable },

  mounted() {
    fetch("/html/answer_6.html")
      .then((response) => response.text())
      .then((html) => {
        this.htmlContent = html;
      })
      .catch((error) => {
        console.error("HTML yüklənmədi:", error);
      });
  },
};
</script>

<style>
.faq-table-wrapper {
  overflow-x: auto;
  max-width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
}

.faq-table th,
.faq-table td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: center;
}
.faq-table th {
  background-color: #e0e0e0;
  font-weight: bold;
}

@media (max-width: 1265px) {
  .faq-table-wrapper {
    width: 50rem;
  }
}

@media (max-width: 960px) {
  .faq-table-wrapper {
    width: 75rem;
  }
}

@media (max-width: 890px) {
  .faq-table-wrapper {
    width: 60rem;
  }
}

@media (max-width: 735px) {
  .faq-table-wrapper {
    width: 50rem;
  }
}

@media (max-width: 670px) {
  .faq-table-wrapper {
    width: 40rem;
  }
}

@media (max-width: 560px) {
  .faq-table-wrapper {
    width: 35rem;
  }
}

@media (max-width: 515px) {
  .faq-table-wrapper {
    width: 28rem;
  }
}

@media (max-width: 440px) {
  .faq-table-wrapper {
    width: 23rem;
  }
}

@media (max-width: 390px) {
  .faq-table-wrapper {
    width: 20rem;
  }
}
@media (max-width: 350px) {
  .faq-table-wrapper {
    width: 18rem;
  }
}
</style>
